import React from "react";
import { RouteObject } from "react-router-dom";

import { ADMIN_ROUTES } from "../../routes";

export const AdminNoPaddingRoutes: RouteObject[] = [
  {
    path: ADMIN_ROUTES.Ai,
    lazy: async () => {
      const { AiRoute } = await import("@src/features/ai/pages/ai/Ai.route");
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.Ai}
            isEnabled={(org, isAdmin) => isAdmin}
            children={AiRoute}
          />
        ),
      };
    },
  },
];
